/**
 * Textos (`ca`) de planta d'Existències (OBR-14 estats de lot, OBR-143 caducitat a la recepció): namespace `planta.stock`.
 * Tall propi: no es toca `ca.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts). Vocabulari: «Existències», mai «Stock».
 */

export const plantaStockCa = {
  'planta.stock': {
    // ── Estat d'un lot (OBR-14) ───────────────────────────────────────────────────────
    // L'ETIQUETA de l'estat («Bloquejat», «Caducat») i la frase de per què no es pot fer servir són de shared
    // (`stockLotStateKey`, `stockStateReason`); aquí només el que és propi de planta.
    writtenReason: 'Motiu: {{reason}}',
    blockedQuantity: 'Bloquejat: {{quantity}}',
    expiredOn: 'Caducat el {{date}}',
    unavailableTitle: 'Lots que no es poden fer servir',
    unavailableHint: 'Els lots bloquejats i els caducats no es proposen ni es poden triar.',
    allLotsUnavailable:
      'Els lots d’aquest article són bloquejats o caducats: no es poden fer servir. Un responsable els pot desbloquejar des del BackOffice.',
    scanLotBlocked: 'El lot {{lot}} és bloquejat i no es pot fer servir.',
    scanLotBlockedReason: 'El lot {{lot}} és bloquejat ({{reason}}) i no es pot fer servir.',
    scanLotExpired: 'El lot {{lot}} és caducat i no es pot fer servir.',
    // L'estat dels lots no s'ha pogut comprovar (mai o fa massa): s'avisa, no es bloqueja res d'amagat.
    statesUnchecked:
      'No s’ha pogut comprovar quins lots estan bloquejats. Comprova-ho abans de fer-ne servir cap.',
    statesStale:
      'L’estat dels lots no s’actualitza des de fa més d’un dia. Comprova que cap lot estigui bloquejat.',

    // ── Caducitat a la recepció (OBR-143) ─────────────────────────────────────────────
    expiryLabel: 'Caducitat',
    expiryMissing: 'Falta la caducitat d’aquesta entrada.',
    expiryUseEstimate: 'Posa una caducitat estimada',
    expiryMissingSummary_one:
      'Falta la caducitat d’{{count}} entrada. Posa-la o fes servir una d’estimada.',
    expiryMissingSummary_other:
      'Falta la caducitat de {{count}} entrades. Posa-la o fes servir una d’estimada.',
    confirmWithoutExpiry: 'Confirma sense caducitat',
    confirmWithoutExpiryHint:
      'Si no la saps, pots confirmar igualment: el gènere entra i l’existència queda a «A regularitzar» fins que s’hi posi la caducitat.',
  },
} as const;
